import './error.scss';

function ErrorPage(props: { message?: string }) {
    return (
        <div className="m-4">
            <h1>Page Error</h1>
            <p>{props.message ? props.message : 'Unable to load page.'}</p>
        </div>
    )
}

export default ErrorPage;